"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _DD7MF4PQcjs = require('./DD7MF4PQ.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/composite/composite-group-label.tsx
var TagName = "div";
var useCompositeGroupLabel = _PTOCUU2Dcjs.createHook.call(void 0, function useCompositeGroupLabel2({ store, ...props }) {
  props = _DD7MF4PQcjs.useGroupLabel.call(void 0, props);
  return props;
});
var CompositeGroupLabel = _PTOCUU2Dcjs.forwardRef.call(void 0, function CompositeGroupLabel2(props) {
  const htmlProps = useCompositeGroupLabel(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useCompositeGroupLabel = useCompositeGroupLabel; exports.CompositeGroupLabel = CompositeGroupLabel;
